
import {
getViewData
} from '../../utils';
import {
APP_LOADING,
APP_FAILURE
} from '../../config/mutation-types';
import Vue from 'vue';
import ToastPlugin from 'vux/src/plugins/toast/index.js'
import LoadingPlugin from 'vux/src/plugins/loading/index.js'


Vue.use(ToastPlugin);
Vue.use(LoadingPlugin);

window.toast = null;
window.loading = null;
var clientInfo = getViewData();

const state = {
clientInfo: clientInfo
}

const getters = {
getterClientInfo: state => state.clientInfo
};

const actions = {
showToast({ commit }, options) {
commit(APP_FAILURE, options)
},
showLoading({ commit }, options) {
commit(APP_LOADING, options)
},
};

const mutations = {
[APP_LOADING](state, data) {
if (window.loading || !data) {
Vue.$vux.loading.hide();
}
if (!data) {
window.loading = Vue.$vux.toast.show({
'show': data && data.show ? data.show : true,
'text': data && data.text ? data.text : '加载中 ...',
'position': data && data.postion ? data.positon : 'middle'
})
}
},
[APP_FAILURE](state, data) {
if (window.toast) {
Vue.$vux.toast.hide();
}
window.toast = Vue.$vux.toast.show({
'time': data && data.time ? data.time : 2500,
'type': data && data.type ? data.type : 'text',
'width': data && data.width ? data.width : '7.6em',
'is-show-mask': data && data.isShowMask ? data.isShowMask : true,
'show': data && data.show ? data.show : true,
'text': data && data.text ? data.text : '消息',
'position': data && data.postion ? data.positon : 'middle'
})
}
};

export default {
state,
getters,
actions,
mutations
};



// WEBPACK FOOTER //
// ./src/store/modules/app.js